module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/icon_complete_sp-79c584b647712c9d29a56d17ccea69ed.png";